import { buildI18nInjectionToken } from '@pct-ng/transloco';

const I18nScope = 'ng/feature/message/material';
export const I18nProviderInjectionToken = buildI18nInjectionToken(I18nScope);
